function mapToLabelValue(list: string[]) {
  return list.map((item) => ({ label: item, value: item }));
}

export const complaintsList = mapToLabelValue([
  'Activation/Provision',
  'Billing/Charges',
  'Customer Experience',
  'Faults',
  "I'm not a customer",
  'My Contract/Package',
  'Privacy and Security',
  'Fraud',
]);

const activationProvisionList = mapToLabelValue([
  "My delivery hasn't arrived",
  'Delay in activating my services',
  "My package isn't as described",
  'My contract price/length is incorrect',
  'Trouble Porting my number',
  'Unable to place an order online',
]);

const billingChargesList = mapToLabelValue([
  'Mobile Insurance',
  'I am unhappy about the arrears process',
  "I don't understand or agree with charges on my bill",
  "I haven't received my bill",
  'I dispute the early termination fee',
  "There's a problem with my payment",
  'Calling international numbers from the UK',
]);

const customerExperienceList = mapToLabelValue([
  'Bereavement Issue',
  'My O2',
  'Complaint Handling',
  'Failed Call Back',
  'Staff Conduct',
  'Long Wait times',
  'Other',
]);

const faultsList = mapToLabelValue([
  'Device',
  'I have a Handset Fault',
  'I have issues with call quality',
  'I have no signal',
  "I'm unable to make/receive a call",
  'Issues with mobile broadband',
  'Issues with my roaming service',
  'Data Issues',
  '3G Turn Off impact',
]);

const notCustomerList = mapToLabelValue([
  'Fraud',
  'Unable to place an order online',
  'Bereavement Issue',
  'Staff Conduct',
  'Virgin Media Marketing',
]);

const myContractPackageList = mapToLabelValue([
  'My contract price/length is incorrect',
  'My personal details are incorrect',
  "I'm trying to Cancel",
  "My package isn't as described",
  'Unhappy with the offers available',
  'Mobile Insurance',
  'My package isn’t as described',
  'Not included in tariff',
  'Missing my promotion/incentive',
  'Calling International Numbers from UK',
  'Charge to Mobile',
  "I don't understand or agree with charges on my bill",
  'Volt',
  'Other',
]);

const privacyAndSecurityList = mapToLabelValue([
  'Fraud',
  'Nuisance Calls',
  'O2 Marketing',
  'Unwanted Sale',
  'GDPR - Data protection issues',
  'Child Access control',
  'DPA',
  'Unwanted emails',
]);

const fraudList = mapToLabelValue(['Fraud Decision Dispute']);

export const complaintsListMap = {
  'Activation/Provision': activationProvisionList,
  'Billing/Charges': billingChargesList,
  'Customer Experience': customerExperienceList,
  Faults: faultsList,
  "I'm not a customer": notCustomerList,
  'My Contract/Package': myContractPackageList,
  'Privacy and Security': privacyAndSecurityList,
  Fraud: fraudList,
};
